/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */


import React from 'react';

const JsonLdPartsProduct = ({ product = {} }) => {
    const {
        sku,
        name,
        image,
        shortDescription,
        brand,
        price,
        priceCurrency = 'EUR',
        availability,
        inStock,
        url,
        model
    } = product;

    const resolvedImage = (() => {
        if (!image) return undefined;
        if (Array.isArray(image)) {
            const first = image[0];
            if (!first) return undefined;
            return typeof first === 'string' ? first : first.src || first.image || first.url;
        }
        if (typeof image === 'object') return image.src || image.image || image.url;
        return image;
    })();

    const resolvedAvailability =
        availability ||
        (inStock === false ? 'https://schema.org/OutOfStock' : 'https://schema.org/InStock');

    const resolvedUrl = url || (typeof window !== 'undefined' ? window.location.href : undefined);

    const normalizedPrice = typeof price === 'string' ? price.replace(',', '.').trim() : price;
    const priceNumber = normalizedPrice !== undefined && normalizedPrice !== null && normalizedPrice !== '' ? Number(normalizedPrice) : NaN;
    const includeOffers = !isNaN(priceNumber) && priceNumber > 0;

    const jsonLd = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name,
        image: [
            resolvedImage
        ],
        description: shortDescription,
        sku: sku,
        brand: {
            "@type": "Brand",
            "name": brand
        },
        itemCondition: "https://schema.org/UsedCondition",
        isAccessoryOrSparePartFor: {
            "@type": "Product",
            "name": `${brand} ${model}`
        }
    };

    if (includeOffers) {
        jsonLd.offers = {
            '@type': 'Offer',
            url: resolvedUrl || undefined,
            priceCurrency,
            price: String(priceNumber),
            availability: resolvedAvailability,
        };
    }

    // remove undefined fields
    const cleaned = JSON.parse(JSON.stringify(jsonLd));

    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(cleaned) }} />
    );
};

export default JsonLdPartsProduct;
